/* ===============
 * FormTransformer
 * ===============
 *
 * The transformer for the Form.
 */

import Transformer from '@transformers/Transformer'

export default class FormTransformer extends Transformer {
  /**
   * Method used to transform a fetched Form.
   *
   * @param data The fetched Form.
   *
   * @returns {Object} The transformed Form.
   */
  static required = []
  static modules = []
  static areass = []

  static fetch (data) {
    const self = this
    self.modules = []
    self.areas = []
    let result = {
      id: data.id,
      name: data.name,
      cID: '',
      areas: [],
      modules: [],
      allAreas: [],
      allModules: []
    }

    if (data.hasOwnProperty('cID')) {
      result.cID = data.cID
    }

    if (data.hasOwnProperty('description')) {
      result.description = data.description
    }

    if (data.hasOwnProperty('areas')) {
      data.areas.forEach((area) => {
        let item = self.parseArea(area)
        self.areas.push(item)
        result.areas.push(item.id)
      })
    }

    result.allModules = self.modules
    result.allAreas = self.areas
    return result
  }

  static parseArea (data) {
    const self = this
    let result = {
      id: data.id,
      name: data.name,
      noprint: data.noprint || 0,
      type: data.type,
      valid: false,
      valid2: 'false',
      collapse: data.collapse,
      areas: [],
      modules: [],
      submodules: [],
      validators: []
    }

    if (data.hasOwnProperty('description')) {
      result.description = data.description
    }

    if (data.hasOwnProperty('required')) {
      result.required = data.required
      data.required.forEach((requiredKey) => {
        data.modules.forEach((module) => {
          if (module.key === requiredKey) {
            self.required.push(module.id)
          }
        })
      })
    }

    if (data.hasOwnProperty('modules')) {
      data.modules.forEach((module) => {
        module.required = false
        module.disabled = false
        module.selected = false
        module.selectInOther = false
        if (self.required.indexOf(module.id) > -1) {
          module.required = true
          module.disabled = true
          module.selected = true
        }
        self.modules.push(module)
        result.modules.push(module.id)
        result.submodules.push(module.id)
      })
    }

    if (data.hasOwnProperty('areas') && data.areas.length > 0) {
      data.areas.forEach((item) => {
        let area = self.parseArea(item)
        self.areas.push(area)
        result.areas.push(area.id)
        if (area.submodules.length > 0) {
          area.submodules.forEach((submodule) => {
            result.submodules.push(submodule)
          })
        }
      })
    }

    if (data.hasOwnProperty('min')) {
      result.validators.push({
        key: 'min',
        valid: false,
        value: data.min
      })
    }

    if (data.hasOwnProperty('max')) {
      result.validators.push({
        key: 'max',
        valid: false,
        value: data.max
      })
    }

    return result
  }
}
